'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopupLink = function (_React$Component) {
  (0, _inherits3.default)(PopupLink, _React$Component);

  function PopupLink() {
    (0, _classCallCheck3.default)(this, PopupLink);
    return (0, _possibleConstructorReturn3.default)(this, (PopupLink.__proto__ || (0, _getPrototypeOf2.default)(PopupLink)).apply(this, arguments));
  }

  (0, _createClass3.default)(PopupLink, [{
    key: 'render',
    value: function render() {
      var propsTo = this.props.to;


      var linkTo = _underscore2.default.isString(propsTo) ? { pathname: propsTo } : propsTo;
      var state = (0, _extends3.default)({}, linkTo.state, {
        modal: true
      });

      var to = (0, _extends3.default)({}, linkTo, {
        state: state
      });

      return _react2.default.createElement(
        _reactRouter.Link,
        (0, _extends3.default)({}, _underscore2.default.omit(this.props, 'query', 'children'), { to: to }),
        this.props.children
      );
    }
  }]);
  return PopupLink;
}(_react2.default.Component);

exports.default = PopupLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PopupLink/PopupLink.jsx
// module id = 2650
// module chunks = 0